import * as THREE from "three";

export class DeviceBox extends THREE.Box3 {
    public Device : any;
}
